export default __webpack_public_path__ + "static/media/Standard41.fd2ff5f9.png";